/**
 * StatusBadge — one reusable program-status pill used everywhere a
 * Maldek program appears (homepage cards, nav dropdown, footer,
 * academy landings). Compact, uppercase, high-contrast, dark-mode-safe.
 *
 * Statuses (never rely on color alone — the written word is always
 * shown and announced to screen readers):
 *   available → Clinical Reasoning Academy, Student Learning, Community Health
 *   testing   → BLS / ACLS Reinforcement
 *   planned   → CNA Workforce Pipeline
 */
const STATUS = {
  available: {
    label: "Available",
    fg: "#0f6f86",
    bg: "#d6f1f6",
    border: "#8fd4e0",
    dot: "#12a3bf",
    sr: "Status: available now",
  },
  testing: {
    label: "Testing",
    fg: "#8a5a12",
    bg: "#fbe9d3",
    border: "#e6c084",
    dot: "#c9871f",
    sr: "Status: currently being tested with limited availability",
  },
  planned: {
    label: "Planned",
    fg: "#465a6e",
    bg: "#e4e9ef",
    border: "#b7c3d1",
    dot: "#6b7f95",
    sr: "Status: planned future program, in development",
  },
};

export function StatusBadge({ status = "available", size = "md", className = "", showDot = true }) {
  const s = STATUS[status] || STATUS.available;
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-bold uppercase tracking-[0.12em] ${pad} ${className}`}
      style={{ color: s.fg, background: s.bg, border: `1px solid ${s.border}`, fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}
      data-testid={`status-badge-${status}`}
    >
      {showDot && (
        <span
          className="inline-block rounded-full"
          style={{ width: 6, height: 6, background: s.dot }}
          aria-hidden="true"
        />
      )}
      <span aria-hidden="true">{s.label}</span>
      <span className="sr-only">{s.sr}</span>
    </span>
  );
}

export default StatusBadge;
